import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PoDatepickerIsoFormat, PoLookupColumn } from '@po-ui/ng-components';
import { defaultEtiquetaMateriaPrimaFornecedor1, EtiquetaMateriaPrimaFornecedor1 } from 'src/app/interface/etiqueta-materia-prima-fornecedor';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { PcpEtiquetaService } from 'src/app/service/pcp-etiqueta-service';
import { ProdutoLookupService } from 'src/app/service/produto-lookup-service';
import { UtilService } from 'src/app/service/util';

@Component({
  selector: 'app-etiqueta-materia-prima-fornecedor1',
  templateUrl: './etiqueta-materia-prima-fornecedor1.component.html',
  styleUrl: './etiqueta-materia-prima-fornecedor1.component.css'
})
export class EtiquetaMateriaPrimaFornecedor1Component {

  etiqueta: EtiquetaMateriaPrimaFornecedor1 = defaultEtiquetaMateriaPrimaFornecedor1();
  fornecedorColumnsFilters: Array<PoLookupColumn> = this.fornecedorLookupService.getColumnsFilter();
  produtoColumnsFilters: Array<PoLookupColumn> = this.produtoLookupService.getColumnsFilter();
  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  constructor(
    private pcpEtiquetaService: PcpEtiquetaService,
    private utilService: UtilService,
    public fornecedorLookupService: FornecedorLookupService,
    public  produtoLookupService: ProdutoLookupService,
  ) {


  }
  @ViewChild( 'formEtiqueta' , { static: true }) formEtiqueta!: NgForm;

  gerarEtiqueta(): void {
    if (this.formEtiqueta.valid){
      this.pcpEtiquetaService.postPcpEtiquetaMateriaPrimaFornecedor1(this.etiqueta).subscribe((res) => {
        var file = new Blob([res], {type: 'application/pdf'});
        var fileName = `${this.etiqueta.CLOTEFORNECEDOR}-${new Date().toISOString()} .pdf`;
        var a = document.createElement("a");
        document.body.appendChild(a);

        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
      });
    }else {
      this.utilService.showErrosFomulario(this.formEtiqueta,document);
    }
  }

  limparTela():void {
    this.etiqueta = defaultEtiquetaMateriaPrimaFornecedor1();
  }

}
